import UniformNode from './UniformNode.js';

class ArrayUniformNode extends UniformNode {
  constructor() {
    let nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    super();
    this.nodes = nodes;
  }

  getNodeType(builder) {
    return this.nodes[0].getNodeType(builder);
  }

}

ArrayUniformNode.prototype.isArrayUniformNode = true;
export default ArrayUniformNode;